import notificationsApiInstance from "./index";

// Backoffice notifications admin — wraps notifications-api's
// GET /api/notifications. organizationId=0 means "all orgs" (platform
// admin only); a tenant scope can still be requested by passing the
// org id explicitly.
export const NotificationsAdminApi = {
  query: (params) =>
    notificationsApiInstance.get("/notifications", {
      params: { organizationId: 0, limit: 200, ...params },
    }),
};

// Per-user in-app inbox. The recipient is always derived from the bearer
// token server-side — there is deliberately no userProfileId parameter to
// pass, because accepting one would let any caller read anyone's inbox.
// Unauthenticated calls get 401 here, unlike the org-scoped producer
// endpoint above which still allows anonymous writes in dev.
export const NotificationsInboxApi = {
  // filter: "unread" | "all" (default, excludes archived) | "archived"
  list: (params = {}) =>
    notificationsApiInstance.get("/notifications/inbox", {
      params: { filter: "all", limit: 50, ...params },
    }),

  // Cheap unread count for the navbar badge.
  count: () => notificationsApiInstance.get("/notifications/inbox/count"),

  // One call covers read/unread/archive/unarchive: { read?, archived? }.
  patch: (publicId, body) =>
    notificationsApiInstance.patch(
      `/notifications/inbox/${encodeURIComponent(publicId)}`,
      body
    ),

  readAll: () => notificationsApiInstance.post("/notifications/inbox/read-all"),

  // Soft delete — the server issues an UPDATE, since notifications.messages
  // has no DELETE policy and a real DELETE would silently affect 0 rows.
  remove: (publicId) =>
    notificationsApiInstance.delete(
      `/notifications/inbox/${encodeURIComponent(publicId)}`
    ),
};

// Digest cadence for the calling user. GET returns EFFECTIVE values, so a
// user who has never saved anything still renders correctly ("immediate").
export const NotificationsPreferencesApi = {
  get: () => notificationsApiInstance.get("/notifications/preferences"),

  // body: { channel: "email", digestCadence, digestHourLocal?, digestDow?,
  //         timezone?, enabled? }
  put: (body) => notificationsApiInstance.put("/notifications/preferences", body),
};

export default NotificationsAdminApi;
